import styled from 'styled-components';

import { black, white } from '../../modules/colors';
import media from '../../modules/media';
import { fonts, spacing } from '../../modules/metrics';

export const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  margin-left: ${spacing.lg}px;

  ${media.desktop} {
    display: none;
  }
`;

export const Image = styled.img`
  object-fit: contain;
  height: 30px;
  width: 30px;
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
`;

export const Arrow = styled.div`
  border-right: 2px solid ${black};
  border-bottom: 2px solid ${black};
  height: 8px;
  width: 8px;
  transform: rotate(${(props) => (props.isMenuOpen ? -135 : 45)}deg);
  transition: transform 0.5s;
  margin-left: ${spacing.lg}px;
`;

export const Menu = styled.ul`
  background-color: ${white};
  border-radius: 6px;
  margin: ${spacing.md}px 0px 0px 0px;
  padding: ${spacing.md}px 0px;
  position: absolute;
  top: 30px;
  right: 0;
  white-space: nowrap;
  z-index: 2;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
`;

export const MenuItem = styled.li`
  color: ${black};
  font-size: ${fonts.sm}px;
  cursor: pointer;
  padding: ${spacing.md}px ${spacing.lg}px;

  :hover {
    background-color: rgb(59, 130, 246);
    color: ${white};
  }
`;
